"use client"

import { useEffect } from "react"
import { usePathname, useRouter } from "next/navigation"
import { useSession } from "next-auth/react"

const CheckLoggedIn = () => {
  const { data: session, status } = useSession()
  const router = useRouter()
  const pathname = usePathname()

  const isLoading = status === "loading"
  const isLoggedIn = !!session?.user?.email

  useEffect(() => {
    if (isLoading) return

    const isAuthPage = pathname.startsWith("/auth")

    if (!isLoggedIn && !isAuthPage) {
      router.replace("/auth/signin")
    } else if (isLoggedIn && pathname === "/auth/signin") {
      router.replace("/")
    }
  }, [isLoading, isLoggedIn, pathname, router])

  return null
}

export default CheckLoggedIn
